<template>
  <a class="location-search-card">
    <div class="location-search-card__icon">
      <svg v-svg
        :symbol="svgIcon"
        size="0 0 40 40"
        role="presentation"
      ></svg>
    </div>
    <div class="location-search-card__text">
      <h3 class="location-search-card__heading h3">{{ name }}</h3>
      <div class="location-search-card__types" :key="type" v-for="type in types">{{ type }}</div>
      <div class="location-search-card__brands">
        <span class="location-search-card__brand active" :key="brand" v-for="brand in brands">{{ brand }}</span>
      </div>
      <address class="location-search-card__address">
        <span class="location-search-card__address-address">{{ address }}</span><br>
        <span class="location-search-card__address-city">{{ city }}</span><span v-if="city && state">,</span>
        <span class="location-search-card__address-state">{{ state }}</span>
        <span class="location-search-card__address-zip">{{ zipcode }}</span>
      </address>
      <div class="location-search-card__phone">
        <a :href="'tel:' + phone"
            v-if="phone">{{ formattedPhone }}</a>
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    props: {
      id: {
        required: true,
        type: String
      },
      name: {
        required: true,
        type: String
      },
      address: {
        required: true,
        type: String
      },
      city: {
        required: true,
        type: String
      },
      state: {
        required: true,
        type: String
      },
      zipcode: {
        required: true,
        type: String
      },
      phone: {
        type: String
      },
      types: {
        type: Array
      },
      icontype: {
        type: String
      },
      brands: {
        type: Array
      },
    },
    computed: {
      formattedPhone() {
        var match = this.phone.match(/^(\d{3})(\d{3})(\d{4})$/)
        if (match) {
          return '(' + match[1] + ') ' + match[2] + '-' + match[3]
        }
      },
      svgIcon() {
        return 'sprite-icon-' + this.icontype.toLowerCase();
      },
    }
  };
</script>
